/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  cleanUpComment,
} from '../../../../utils/helpers';
import useCustomQuery from '../../../../network/useCustomQuery';
import useGetQueryParams from '../../../../customHooks/useGetQueryParams';
import { GET_USERS_COMMENT } from '../../../../graphql/admin_queries';
import AdminTable from '../../../../components/AdminTable';
import DashboardHeader from '../../../../components/DashboardHeader';
import useToast from '../../../../customHooks/useToast';
import useFilterMethods from '../../../../customHooks/useFilterMethods';
import EmptyRecord from '../../../../components/EmptyRecord';
import useTableColumn from '../../../../customHooks/useTableColumn';
import generatePDF from '../../../../utils/generatePdf';
import generateCSV from '../../../../utils/generateCSV';
import EmptyMerchantSettlement from '../../../../svgs/EmptyMerchantSettlement';
import CommentModal from './CommentModal';

const limit = 14;
interface ICommentRecords{
defaultUrl?:string;
toggleStorageId?:string;
tabStatus?:string;
hasNameAndImage?:boolean;
id?:any;
queryType?:string;
}
const CommentRecords = ({
  defaultUrl, toggleStorageId, tabStatus, hasNameAndImage, id, queryType,
}:ICommentRecords) => {
  const Toast = useToast();
  const [getComment, getCommentLoading, comment] = useCustomQuery({
    query: GET_USERS_COMMENT,
    onError: () => {},
    onData: () => {},
  });

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();
  const allColumns = [
    'admin',
    'email',
    'action',
    'comment',
    'createdAtDate',
  ];
  const columnLabelFormat = {
    admin: 'Admin',
    email: 'Email Adddress',
    action: 'Comment About',
    comment: 'Comment',
    createdAtDate: 'Date',
  };
  const { getColumns, applyChanges, selectedColumns } = useTableColumn(allColumns, toggleStorageId);

  const [commentRec, setcommentRec] = useState(null);
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`${defaultUrl}?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    push(`${defaultUrl}?page=1&search=${encodeURIComponent(e.target.value)}`);
  };
  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getComment({
        variables: tabStatus ? {
          id,
          offset: (page - 1) * limit,
          limit,
          search,
          filters: {
            from: result.from,
            to: result.to,
          },
        } : {
          id,
          offset: (page - 1) * limit,
          limit,
          search,
          filters: {
            from: result.from,
            to: result.to,
          },
        },
      });
    }
  }, [page, search]);

  const onFilterSubmit = (result) => {
    getComment({
      variables: {
        id,
        offset: 0,
        limit,
        search,
        filters: {
          from: result.from,
          to: result.to,
        },
      },
    });
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: ['dateRange'],
    defaultUrl,
    cb: onFilterSubmit,
    Toast,
  });

  useEffect(() => {
    if (comment?.getMerchantComments) {
      setcommentRec(comment?.getMerchantComments);
    }
    if (comment?.getUserComments) {
      setcommentRec(comment?.getUserComments);
    }
  }, [comment]);

  const [getExportRecord] = useCustomQuery({
    query: GET_USERS_COMMENT,
    onError: () => {},
    onData: () => {},
  });

  const handleExport = async (type: string) => {
    try {
      const result = getFilterQueries();
      const output = await getExportRecord({
        variables: {
          id,
          offset: 0,
          limit: 2000,
          search,
          filters: {
            from: result.from,
            to: result.to,
          },
        },
      });
      if (output?.data) {
        const rec = queryType ? cleanUpComment(output?.data?.getUserComments?.data) : cleanUpComment(output?.data?.getMerchantComments?.data);
        const func = type === 'pdf' ? generatePDF : generateCSV;
        const selectedHeaders = [
          'S/N',
          // change image__email__hasBottomValue__name concated columns to a single column of name
          ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
        ];

        func({
          payload: rec,
          title: 'COMMENT',
          selectedHeaders,
          formatHeaders: columnLabelFormat,
          cb: () => Toast.success('Exported successfully'),
        });
      }
    } catch (error) {
      Toast.error('Error while exporting');
    }
  };
  // const routeToMerchantDetails = (data) => {
  //   setItemsToLocalStorage('id', data?.id);
  //   setItemsToLocalStorage('merchant-details-nav-status', {
  //     name: data?.name,
  //     logo: data?.logo,
  //     status: data?.merchantStatus,
  //   });
  //   push(`/merchant-details/${data?.id}/kyc`);
  //   setItemsToLocalStorage('currentRoute', 0);
  // };
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentContent, setCommentContent] = useState('');
  const handleClick = (data) => {
    setShowCommentModal(true);
    setCommentContent(data.comment);
  };
  return (
    <div>
      <DashboardHeader
        title="Comments"
        smallSubTitle={`(${commentRec?.count || 0})`}
        searchPlaceholder="Search by Admin Name, Email, Comment About"
        search={search}
        onSearchChange={onSearchChange}
        searchLoading={getCommentLoading}
        filterObj={filterObj}
        columnObject={{
          allColumns,
          formatLabels: columnLabelFormat,
          applyChanges,
          selectedColumns,
        }}
        exportObj={{
          handleExport,
        }}
      />
      <div className="settlement-table-details-cover">
        {commentRec?.count ? (
          <AdminTable
            refreshing={getCommentLoading}
            page={page}
            setPage={setPage}
            pageSize={limit}
            minHeight="calc(100vh - 280px)"
            count={commentRec?.count}
            contents={cleanUpComment(commentRec?.data)}
            reference="id"
            hideDominantImage
            clickable
            handleClick={handleClick}
            hasNameAndImage={hasNameAndImage}
            allowKeyArr={getColumns(true)}
            mobileAllowKeyArr={
              [
                '',
                ['admin', 'email'],
                ['action', 'date'],
              ]
            }
            formatLabels={columnLabelFormat}
          />
        ) : (
          <EmptyRecord
            height="400px"
            title={getCommentLoading ? 'Fetching comments...' : 'No Comment yet'}
            main={queryType ? 'Customer has no comment.' : 'Merchant has no comment.'}
            // footer="Receive Payments"
            loading={getCommentLoading}
            Icon={EmptyMerchantSettlement}
          />
        )}

      </div>
      {
        showCommentModal && <CommentModal comment={commentContent} closeModal={() => setShowCommentModal(false)} />
      }

    </div>
  );
};
export default CommentRecords;
